<template>
  <z-page class="user-list">
    <div class="page-search" v-if="$store.getters.userInfo.isAdmin">
      <div @click="tonumManage" class="z-btn">工号管理</div>
    </div>

    <!-- 列表 -->

    <div class="page-list">
      <div class="list-head">
        <div>账号</div>
        <div>工号</div>
        <div>姓名</div>
        <div>部门</div>
        <div>身份</div>
        <div>入职时间</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div class="list-item" v-for="item in data.list" :key="item.account">
          <div>{{ item.account }}</div>
          <div>{{ item.workerId }}</div>
          <div>{{ item.name ||'--'}}</div>
          <div>{{ item.groupName }}</div>
          <div>{{ item.identityName }}</div>
          <div>{{ item.addTime }}</div>
        </div>
      </div>
    </div>
    <z-pagination
      @sizeChange="searchData()"
      @pageChange="handleCurrentChange"
      :current-page.sync="now_page"
      :page-size="10"
      :total="total"
    ></z-pagination>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      search: {
        department_id: "",
        department_option: [],
        text: "",
        text_type: 1
      },

      
      url: "",
      loading: false,
      now_page: 1,
      total: 1,
      data: {}
    };
  },

  created() {
    this.searchData();
  },

  methods: {
    tonumManage() {
      this.$func.getsasstoken().then(res => {
        let tempPage = window.open("", " _blank");
        this.url =
          `${this.$url.GH}/Number/?to_url=numManage/workNum&token=` +
          res.data.server_response.once_token;
        tempPage.location = this.url;
      });
    },
    jsPost(URL, PARAMS, TARGET) {
      var temp = document.createElement("form");
      temp.action = URL;
      temp.method = "post";
      temp.style.display = "none";
      if (!TARGET) {
        TARGET = "_self";
      }
      temp.target = TARGET;
      for (var x in PARAMS) {
        var opt = document.createElement("textarea");
        opt.name = x;
        opt.value = PARAMS[x];
        temp.appendChild(opt);
      }
      document.body.appendChild(temp);
      temp.submit();
      return temp;
    },
    handleCurrentChange(val) {
      this.now_page = val;
      this.getData(this.now_page);
    },
    searchData() {
      this.getData(this.now_page);
    },
    getData(num = 1) {
      this.loading = true;
      let url = `/api/supplier/get/employee/list`;
      this.$http
        .get(url, {
          params: {
            page: num
          }
        })
        .then(res => {
          if (res.code == 200) {
            this.data = res.res_data;
            this.total = res.res_data.total;
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.list-head,
.list-item {
  div {
    width: 15%;
    &:nth-child(1) {
      width: 20%;
    }
    &:nth-child(2) {
      width: 17%;
    }
  }
}
</style>
